var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "component-item" },
    [
      _vm.mobileCheckBarShow
        ? _c("mobile-check-bar", { attrs: { element: _vm.config } })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "inner-item", style: _vm.commonStyle },
        [
          _vm.svgInnerEnable
            ? _c("svg-icon", {
                staticClass: "svg-background",
                style: { color: _vm.config.commonBackground.innerImageColor },
                attrs: { "icon-class": _vm.mainSlotSvgInner },
              })
            : _vm._e(),
          _vm.config.type === "custom"
            ? _c("de-out-widget", {
                staticClass: "component-custom",
                style: _vm.getComponentStyleDefault(_vm.config.style),
                attrs: {
                  id: "component" + _vm.config.id,
                  "out-style": _vm.outStyle,
                  element: _vm.config,
                  "in-screen": true,
                },
              })
            : _c(_vm.config.component, {
                ref: "wrapperChild",
                tag: "component",
                style: _vm.getComponentStyleDefault(_vm.config.style),
                attrs: {
                  "out-style": _vm.outStyle,
                  "prop-value": _vm.config.propValue,
                  "is-edit": false,
                  element: _vm.config,
                  h: _vm.outItemHeight,
                  "canvas-style-data": _vm.canvasStyleData,
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }